import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input
} from "@angular/core";
import { PackagePricePipe } from "src/app/pipes/package-price.pipe";
import { PriceDiffPipePipe } from "src/app/pipes/price-diff-pipe.pipe";
import { PricePipe } from "src/app/pipes/sharedpipes/price.pipe";
import { FormService } from "src/app/services/form.service";
import { PackageResponse } from "src/domain/client";

@Component({
    selector: "app-total-price",
    imports: [PricePipe, PriceDiffPipePipe, PackagePricePipe],
    templateUrl: "./total-price.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TotalPriceComponent {
  package = input<PackageResponse>();

  _formService = inject(FormService);
}
